<template>
  <div class="income">
    <a-row>
      <a-col span="20">
        <a-space :size="15">
          <IncomeTypeSelect v-model="params.type" style="width:105px;"/>
          <DatePicker :show-time="false" @keydown.stop format="YYYY-MM-DD"
                      placeholder="开始时间" style="min-width: 160px; max-width: 160px" v-model="params.start"/>
          <DatePicker :show-time="false" @keydown.stop format="YYYY-MM-DD"
                      placeholder="结束时间" style="min-width: 160px; max-width: 160px" v-model="params.finish"/>
          <a-button icon="search" @click="search">搜索</a-button>
        </a-space>
      </a-col>
      <a-col span="4" style="text-align:right;">
        <ChargeButton ref="charge" @done="refresh"/>
      </a-col>
    </a-row>
    <a-table
        style="margin-top:20px;" rowKey="id"
        :data-source="result.data" :columns="columns" :loading="loading" bordered>
      <template slot="detail" slot-scope="item">
        <b>{{ item.subject }}</b>
        <div class="comment">{{ item.comment }}</div>
        <div class="photos">
          <a-row :gutter="15">
            <a-col v-for="(photo, index) in photos(item)" :xxl="2" :xl="3" :lg="4" :key="index">
              <ResourceImg :id="photo['thumb_id']" resize="m_8,w_300,h_300"/>
              <div>{{ photo['file_name'] }}</div>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import api from "@/utils/api";
import func from "@/utils/func";
import DatePicker from "@/comps/DatePicker";
import ResourceImg from "@/comps/ResourceImg";
import DelayLoading from "@/comps/DelayLoading";
import ChargeButton from "@/pages/index/ucenter/comps/ChargeButton";
import IncomeTypeSelect from "@/pages/index/ucenter/comps/IncomeTypeSelect";

export default {
  name: "Income",
  mixins: [DelayLoading],
  components: {ResourceImg, IncomeTypeSelect, ChargeButton, DatePicker},
  data() {
    return {
      params: {
        type: 0,
        start: 0,
        finish: 0,
        page_no: 1,
        page_size: 10
      },
      result: {
        total: 0,
        data: []
      },
      columns: [
        {
          width: 160,
          title: "账单金额",
          dataIndex: "amount",
          customRender: (v) => func.formatCNF(v)
        },
        {
          title: "账单详情",
          scopedSlots: {
            customRender: "detail"
          }
        },
        {
          title: "出账时间", dataIndex: "created_at",
          width: 160, customRender: (v) => func.tsFormat(v)
        }
      ]
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    load() {
      const self = this;
      let args = Object.assign({}, self.params, {
        finish: self.params.finish ? self.params.finish + (24 * 3600 - 1) : 0
      });
      this.withLoading(300, () => {
        return api.v1.user.income.search(args)
            .then(res => self.result = res);
      });
    },
    refresh() {
      this.params.type = 0;
      this.params.start = 0;
      this.params.finish = 0;
      this.search();
    },
    search() {
      this.params.page_no = 1;
      this.load();
    },
    photos(item) {
      let extend = item.extend["photos"];
      return extend ? JSON.parse(extend) : [];
    }
  }
}
</script>

<style scoped lang="less">
.income {
  .comment {
    margin: 5px 0;
  }

  .photos {
    text-align: center;

    img {
      margin: 5px 0;
      max-width: 100%;
      border-radius: 4px;
    }
  }
}
</style>